'use client';
import { useParams } from 'next/navigation';
import React, { useState } from 'react';

import { Text } from '~components/Typography';
import { usePaywallContext } from '~context/paywall';
import { PaymentReason } from '~features/annals';
import { annals } from '~features/annals/hooks';
import { useSubscriptions } from '~hooks/useSubscriptions';
import { useTranslations } from '~i18n/hooks';
import DiamondIcon from '~public/assets/icons/navigation/dimond.svg';
import { DropdownElement } from '~shared/ui/atoms';
import { MySubscriptions } from '~widgets/MySubscriptions';

export const MySubscriptionsItem = () => {
	const { recipientId: botClientId } = useParams<{ recipientId?: string }>();
	const t = useTranslations('ProfileMenu');

	const [isOpen, setIsOpen] = useState(false);

	const { openPaywall } = usePaywallContext();
	const { activeSubscription } = useSubscriptions();

	const reasonType = annals.checkout.usePaymentReasonType();

	return (
		<>
			<DropdownElement
				data-name="subscription-item"
				icon={<DiamondIcon />}
				onClick={() => {
					if (activeSubscription) {
						setIsOpen(true);
					} else {
						openPaywall({
							reason: PaymentReason.LeftMenu,
							reasonType,
							prefer: 'subscription',
							botClientId,
						})();
					}
				}}
			>
				<Text size="M" align="left">
					{t('subscriptionTitle')}
				</Text>
			</DropdownElement>
			{isOpen && (
				<MySubscriptions
					onClose={() => setIsOpen(false)}
					activeSubscription={activeSubscription}
				/>
			)}
		</>
	);
};
